<template>
  <v-data-table
    :headers="headers"
    :items="listOfUsers"
    :items-per-page="5"
    sort-by="username"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>All Users Registered</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="570px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on" disabled>Add New User</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="9">
                    <v-text-field v-model="editedItem.username" label="Username" outlined></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-row justify="end" align="center">
                      <v-switch v-model="editedItem.active" color="teal" label="Active"></v-switch>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="6" md="8">
                    <v-select
                      v-model="editedItem.proffession"
                      :items="professions"
                      label="Profession"
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-select v-model="editedItem.role" :items="roles" label="User Role" outlined></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
      <v-icon small @click="deleteUser(item._id)">mdi-delete</v-icon>
    </template>
    <template v-slot:no-data>
      <span class="headline font-weight-bold">No User Registration Request, yet!</span>
    </template>
  </v-data-table>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    dialog: false,
    headers: [
      {
        text: "First Name",
        align: "left",
        sortable: false,
        value: "firstName"
      },
      { text: "Last Name", value: "lastName" },
      { text: "User Name", value: "username" },
      { text: "Profession", value: "proffession" },
      { text: "Actions", value: "action", sortable: false }
    ],
    roles: ["user", "admin"],
    professions: ["Software Engineer", "Student", "Developer", "Other"],
    editedIndex: -1,
    editedItem: {
      username: "",
      proffession: "",
      role: "",
      active: true
    },
    defaultItem: {
      username: "",
      proffession: "",
      role: "",
      active: true
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New User" : "Edit User";
    },
    ...mapState("auth", ["listOfUsers"])
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.getAllUsers();
  },

  methods: {
    ...mapActions("auth", ["getAllUsers", "updateUser", "deleteUser"]),

    editItem(item) {
      this.editedIndex = this.listOfUsers.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.listOfUsers.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.listOfUsers.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.listOfUsers[this.editedIndex], this.editedItem);
        this.updateUser(this.editedItem)
      } else {
        this.listOfUsers.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>